module.exports = __webpack_public_path__ + "img/cs-2.e43aed9a.png";